var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 -0.34 15.996 15.996",
    id: "star-16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-14,1.689l1.965,4.143a1,1,0,0,0,.815.568L-7,6.774l-3.049,2.94a1,1,0,0,0-.295.87L-9.677,15l-3.808-2.31A1,1,0,0,0-14,12.544a1,1,0,0,0-.519.146l-3.8,2.31.668-4.416a1,1,0,0,0-.294-.869L-21,6.774l4.215-.374a1,1,0,0,0,.815-.567L-14,1.689m0-1a1,1,0,0,0-.9.571L-16.873,5.4l-4.215.373a1,1,0,0,0-.855.663,1,1,0,0,0,.249,1.053l3.046,2.941-.668,4.416a1,1,0,0,0,.435.982.993.993,0,0,0,.554.168,1,1,0,0,0,.519-.145L-14,13.544l3.807,2.311A1,1,0,0,0-9.677,16a1,1,0,0,0,.554-.168,1,1,0,0,0,.434-.982l-.67-4.416L-6.31,7.493a1,1,0,0,0,.249-1.052,1,1,0,0,0-.855-.664L-11.134,5.4-13.1,1.261A1,1,0,0,0-14,.689Z",
    transform: "translate(22 -0.689)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fa3181b6f4a90e4f32415cc14f57f2dc.svg";
export { ForwardRef as ReactComponent };